<template>
  <div class="page-wrapper home">
    <div id="header" class="header pt-3 pb-3 mb-5">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-6 col-md-12 mx-auto">
            <div class="grid">
              <p class="mt-4" data-aos="fade-right">
                A <b>trailblazing story!</b> That is how we could describe our
                journey in this highly competitive, fast paced and ever changing
                automotive industry. <i>MANO TOOLS</i> a private sector company
                which has been established as a proprietary unit during 1996 as
                a permanent small scale industry under the company act of 1956.
                The company has been serving for the past 25 years and is proud
                to be a part of the growing automotive industry in our country.
                The unit has adapted itself to the changing needs of the
                automotive industries and updates its machines and system to
                achieve continual improvement in the quality of its
                manufacturing processes.
              </p>
            </div>
          </div>
          <div class="col-lg-push-1 col-md-6 mx-auto">
            <div class="iframe-container">
              <iframe
                data-aos="fade-left"
                width="560"
                height="315"
                src="https://www.youtube.com/embed/tRE7zrqQSRk?rel=0&autoplay=1&mute=1&controls=1&playlist=tRE7zrqQSRk&loop=1"
                title="25th Year"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div data-aos="fade-in" id="container">
      <h3 class="scw">Scope Of Work</h3>
    </div>
    <div class="container-fluid">
      <img
        data-aos="fadeLeft"
        src="../assets/img/scopeofwork.png"
        alt="Scope of Field"
        width="100%"
        height="50%"
      />
    </div>
    <div id="container2" data-aos="fade-down" class="heading3">
      <h3>Growth is a result for working together</h3>
    </div>
    <div class="timeline container">
      <section class="timeline-sec">
        <div class="wrapper">
          <div class="timeline-main">
            <div class="timeline-row">
              <div class="timeline-box">
                <h6>1996</h6>
                <p>
                  Established with a single machine and started handling Labour
                  Jobs
                </p>
              </div>
              <div class="timeline-box">
                <h6>1997</h6>
                <p>
                  Procurement of Machines phase: Various machines were Erected
                </p>
              </div>
              <div class="timeline-box">
                <h6>2000</h6>
                <p>
                  Developed into a Small Scale Tool Room company on a Rental
                  area
                </p>
              </div>
              <div class="horizontal-line"></div>
              <div class="verticle-line"></div>
              <div class="corner top"></div>
              <div class="corner bottom"></div>
            </div>
            <div class="timeline-row">
              <div class="timeline-box">
                <h6>2007</h6>
                <p>
                  Opened our first Renowned plant with an area of 1500 Sq.ft
                </p>
              </div>
              <div class="timeline-box">
                <h6>2008</h6>
                <p>
                  Grouped the organization under the MSME CATEGORY and got
                  certified Under it
                </p>
              </div>
              <div class="timeline-box">
                <h6>2014</h6>
                <p>
                  Procured & Erected VERTICAL MACHINING CENTRE(VMC) at our
                  premises
                </p>
              </div>
              <div class="horizontal-line"></div>
              <div class="verticle-line"></div>
              <div class="corner top"></div>
              <div class="corner bottom"></div>
            </div>

            <div class="timeline-row">
              <div class="timeline-box">
                <h6>2015</h6>
                <p>ESI scheme for Employees was launched</p>
              </div>
              <div class="timeline-box">
                <h6>2016</h6>
                <p>New Property Purchased for plant expansion</p>
              </div>
              <div class="timeline-box">
                <h6>2018</h6>
                <p>IMPORT EXPORT (IEC) Certified Holder</p>
              </div>
              <div class="horizontal-line"></div>
              <div class="verticle-line"></div>
              <div class="corner top"></div>
              <div class="corner bottom"></div>
            </div>
            <div class="timeline-row">
              <div class="timeline-box">
                <h6>2019</h6>
                <p>SOLIDWORKS 2020 Perpetual License Holder</p>
              </div>
              <div class="timeline-box">
                <h6>2020</h6>
                <p>New Plant of 3000 Sq.ft for Conventional Machines</p>
              </div>
              <div class="horizontal-line"></div>
              <div class="verticle-line"></div>
              <div class="corner top"></div>
              <div class="corner bottom"></div>
            </div>

            <div class="timeline-row">
              <div class="timeline-box">
                <img
                  src="../assets/img/25yrs.png"
                  alt="Logo"
                  class="timelinelast"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  components: {}
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.mt-3 {
  margin-top: 0.9rem !important;
}
.grid {
  display: grid;
  place-items: center;
  height: 100%;
  p {
    text-align: justify;
    line-height: 1.9;
  }
}

.header {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3Crect stroke='%23ffffff' stroke-width='0.54' width='1' height='1' id='s'/%3E%3Cpattern id='a' width='3' height='3' patternUnits='userSpaceOnUse' patternTransform='rotate(25 1000 750) scale(12.05) translate(-917.01 -687.76)'%3E%3Cuse fill='%23fafafa' href='%23s' y='2'/%3E%3Cuse fill='%23fafafa' href='%23s' x='1' y='2'/%3E%3Cuse fill='%23f5f5f5' href='%23s' x='2' y='2'/%3E%3Cuse fill='%23f5f5f5' href='%23s'/%3E%3Cuse fill='%23f0f0f0' href='%23s' x='2'/%3E%3Cuse fill='%23f0f0f0' href='%23s' x='1' y='1'/%3E%3C/pattern%3E%3Cpattern id='b' width='7' height='11' patternUnits='userSpaceOnUse' patternTransform='rotate(25 1000 750) scale(12.05) translate(-917.01 -687.76)'%3E%3Cg fill='%23ebebeb'%3E%3Cuse href='%23s'/%3E%3Cuse href='%23s' y='5' /%3E%3Cuse href='%23s' x='1' y='10'/%3E%3Cuse href='%23s' x='2' y='1'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='8'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='5' y='2'/%3E%3Cuse href='%23s' x='5' y='6'/%3E%3Cuse href='%23s' x='6' y='9'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='h' width='5' height='13' patternUnits='userSpaceOnUse' patternTransform='rotate(25 1000 750) scale(12.05) translate(-917.01 -687.76)'%3E%3Cg fill='%23ebebeb'%3E%3Cuse href='%23s' y='5'/%3E%3Cuse href='%23s' y='8'/%3E%3Cuse href='%23s' x='1' y='1'/%3E%3Cuse href='%23s' x='1' y='9'/%3E%3Cuse href='%23s' x='1' y='12'/%3E%3Cuse href='%23s' x='2'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='2'/%3E%3Cuse href='%23s' x='3' y='6'/%3E%3Cuse href='%23s' x='3' y='11'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='4' y='10'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='c' width='17' height='13' patternUnits='userSpaceOnUse' patternTransform='rotate(25 1000 750) scale(12.05) translate(-917.01 -687.76)'%3E%3Cg fill='%23e5e5e5'%3E%3Cuse href='%23s' y='11'/%3E%3Cuse href='%23s' x='2' y='9'/%3E%3Cuse href='%23s' x='5' y='12'/%3E%3Cuse href='%23s' x='9' y='4'/%3E%3Cuse href='%23s' x='12' y='1'/%3E%3Cuse href='%23s' x='16' y='6'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='d' width='19' height='17' patternUnits='userSpaceOnUse' patternTransform='rotate(25 1000 750) scale(12.05) translate(-917.01 -687.76)'%3E%3Cg fill='%23ffffff'%3E%3Cuse href='%23s' y='9'/%3E%3Cuse href='%23s' x='16' y='5'/%3E%3Cuse href='%23s' x='14' y='2'/%3E%3Cuse href='%23s' x='11' y='11'/%3E%3Cuse href='%23s' x='6' y='14'/%3E%3C/g%3E%3Cg fill='%23e0e0e0'%3E%3Cuse href='%23s' x='3' y='13'/%3E%3Cuse href='%23s' x='9' y='7'/%3E%3Cuse href='%23s' x='13' y='10'/%3E%3Cuse href='%23s' x='15' y='4'/%3E%3Cuse href='%23s' x='18' y='1'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='e' width='47' height='53' patternUnits='userSpaceOnUse' patternTransform='rotate(25 1000 750) scale(12.05) translate(-917.01 -687.76)'%3E%3Cg fill='%23ffffff'%3E%3Cuse href='%23s' x='2' y='5'/%3E%3Cuse href='%23s' x='16' y='38'/%3E%3Cuse href='%23s' x='46' y='42'/%3E%3Cuse href='%23s' x='29' y='20'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='f' width='59' height='71' patternUnits='userSpaceOnUse' patternTransform='rotate(25 1000 750) scale(12.05) translate(-917.01 -687.76)'%3E%3Cg fill='%23ffffff'%3E%3Cuse href='%23s' x='33' y='13'/%3E%3Cuse href='%23s' x='27' y='54'/%3E%3Cuse href='%23s' x='55' y='55'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='g' width='139' height='97' patternUnits='userSpaceOnUse' patternTransform='rotate(25 1000 750) scale(12.05) translate(-917.01 -687.76)'%3E%3Cg fill='%23ffffff'%3E%3Cuse href='%23s' x='11' y='8'/%3E%3Cuse href='%23s' x='51' y='13'/%3E%3Cuse href='%23s' x='17' y='73'/%3E%3Cuse href='%23s' x='99' y='57'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23b)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23h)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23c)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23d)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23e)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23f)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23g)' width='100%25' height='100%25'/%3E%3C/svg%3E");
  background-size: cover;
}

.page-header {
  font-size: 40px;
  text-transform: uppercase;
}

#container {
  margin: 0 auto;
  max-width: 850px;
  text-align: center;
}

#container2 {
  margin: 0 auto;
  max-width: 1000px;
  text-align: center;
}

.scw {
  overflow: hidden;
  text-align: center;
  color: #010181;
  text-transform: uppercase;
  font-size: 2em;
  // letter-spacing: 3px;
}

.scw:before,
.scw:after {
  content: "";
  display: inline-block;
  height: 1px;
  position: relative;
  top: -2px;
  vertical-align: middle;
}

.scw:before {
  background-color: #010181;
  left: -0.5em;
  margin-left: -100%;
  width: 100%;
}

.scw:after {
  background-color: #010181;
  left: 0.5em;
  margin-right: -100%;
  width: 100%;
}

h3 {
  margin: 4%;
  text-transform: uppercase;
  text-align: center;
  font-size: 2rem;
  font-weight: 100;
}

* {
  box-sizing: border-box;
}
h3 {
  font-weight: 400;
  color: #010181;
}

.heading3 h3 {
  overflow: hidden;
  text-align: center;
  text-transform: uppercase;
  // letter-spacing: 3px;
  font-size: 2em;
}

.heading3 h3:before,
.heading3 h3:after {
  content: "";
  display: inline-block;
  height: 1px;
  position: relative;
  top: -2px;
  vertical-align: middle;
}

.heading3 h3:before {
  background-color: #555;
  left: -0.5em;
  margin-left: -100%;
  width: 100%;
}

.heading3 h3:after {
  background-color: #555;
  left: 0.5em;
  margin-right: -100%;
  width: 100%;
}
body {
  background: #f6f9fc;
  color: #525f7f;
}
h2 {
  margin: 2%;
  text-transform: uppercase;
  text-align: center;
  font-size: 2rem;
  font-weight: 100;
}

//home content starts
.homeunit {
  border-radius: 25px;
  box-shadow: 15px 10px 25px -9px rgba(155, 155, 155, 1);
  width: 74%;
  height: auto;
  margin: auto;
  display: block;
}
.story {
  margin-top: 4%;
  p {
    font-size: 20px;
    word-spacing: 5px;
    line-height: 35px;
  }
}

//home content ends

@import url("https://fonts.googleapis.com/css2?family=Open+Sans&display=swap");

.wrapper {
  width: 95%;
  margin: 0 auto;
}

.timeline-sec {
  padding: 80px 0 10px 0;
}

.timeline-row {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding-bottom: 130px;
  position: relative;
}

.timeline-box {
  width: 33.33%;
  position: relative;
}

.timeline-box::after {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(50%, -50%);
  -webkit-transform: translate(50%, -50%);
  content: "";
  background-image: url("../assets/icons/rightarrow.png");
  width: 40px;
  height: 40px;
  background-repeat: no-repeat;
}

.timeline-row::after {
  position: absolute;
  width: 40px;
  height: 40px;
  content: "";
  background-image: url("../assets/icons/rightarrow.png");
  background-repeat: no-repeat;
  right: 0;
  top: 50%;
  z-index: 3;
  transform: translate(50%, -50%) rotate(90deg);
  -webkit-transform: translate(50%, -50%) rotate(90deg);
}

.timeline-row:nth-child(2n + 2)::after {
  right: auto;
  left: 0;
  transform: translate(-50%, -50%) rotate(90deg);
  -webkit-transform: translate(-50%, -50%) rotate(90deg);
}

.timeline-row:nth-child(2n + 2) .timeline-box::after {
  transform: translate(50%, -50%) rotate(180deg);
  -webkit-transform: translate(50%, -50%) rotate(180deg);
  left: -50%;
}

.timeline-row:nth-child(2n + 2) .timeline-box:nth-child(3)::after {
  display: none;
}

.timeline-row:nth-child(2n + 2) {
  justify-content: center;
  padding-left: 6%;
}

.timeline-row:nth-child(2n + 2) .timeline-box {
  width: 30%;
}

.timeline-row:nth-child(2n + 2) .timeline-box p {
  width: 76%;
}

.timeline-row:first-child .timeline-box:first-child h6::after {
  width: 120%;
  height: 120%;
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  background: transparent;
  border-radius: 100%;
  z-index: 0;
  border: 2px solid #e5e5e5;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
}

.timeline-row:first-child .timeline-box:first-child h6 {
  background-color: #010181;
  border: 10px solid #fff;
  color: #fff;
}

.timeline-box h6 {
  position: relative;
  color: #010181;
  border: 2px solid #e5e5e5;
  width: 104px;
  height: 104px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  margin-top: -53px;
}

.timeline-box p {
  background-color: #f7f7f7;
  padding: 33px 40px;
  font-size: 14px;
  color: #000000;
  text-align: center;
  font-weight: 400;
  line-height: 1.3;
  width: 65%;
  margin: 24px 0 0 50px;
  position: relative;
}

.timeline-box p::before {
  width: 0;
  height: 0;
  border-bottom: 15px solid #f7f7f7;
  border-right: 17px solid transparent;
  position: absolute;
  top: -14px;
  left: 0;
  content: "";
}

.timeline-row:last-child {
  justify-content: center;
  position: relative;
  padding-bottom: 70px;
}

.timeline-row:last-child::after {
  position: absolute;
  top: 0;
  left: 3%;
  width: 47%;
  height: 0;
  content: "";
  background-color: transparent;
  background-image: none;
  transform: none;
  z-index: 0;
  border-top: 2px dotted #e5e5e5;
}

.timeline-row:nth-last-child(1):nth-child(even):after {
  right: 30%;
  left: initial;
}

.timeline-row:last-child .timeline-box::after {
  display: none;
}

.timeline-row:last-child .timeline-box {
  width: auto;
  z-index: 1;
  margin-top: -2%;
  margin-left: 8%;
}

.timeline-sec .local-solutions-txt {
  font-size: 24px;
}

.timeline-row .horizontal-line {
  border-top: 2px dotted #e5e5e5;
  width: calc(100% - 100px);
  margin: 0 auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: -1;
}

.timeline-row .verticle-line {
  margin: 0;
  padding: 0;
  width: 2px;
  border-right: 2px dotted #e5e5e5;
  height: calc(100% - 100px);
  position: absolute;
  top: 0;
  right: 0;
  margin: auto 0;
  bottom: 0;
}

.timeline-row:nth-child(2n + 2) .verticle-line {
  left: 0;
  right: inherit;
}

.corner {
  position: absolute;
  border-right: 2px dotted #e5e5e5;
  width: 50px;
  height: 50px;
  right: 0;
  border-top: 2px dotted #e5e5e5;
  top: 0px;
  border-radius: 0 70px 0 0;
}

.corner.bottom {
  bottom: -2px;
  top: inherit;
  border-radius: 0;
  border-top: 0;
  border-bottom: 2px dotted #e5e5e5;
  border-radius: 0 0 70px 0;
  right: 0;
}

.timeline-row:nth-child(2n + 2) .corner {
  right: inherit;
  left: 0;
  border-left: 2px dotted #e5e5e5;
  border-right: 0;
  border-radius: 70px 0 0 0;
}

.timeline-row:nth-child(2n + 2) .corner.bottom {
  border-radius: 0 0 0 70px;
}

.timeline-row:nth-child(2n + 2) {
  flex-direction: row-reverse;
}
/*-----Testimonial part-------*/

/*****************************************/
/************** Responsive ***************/
/*****************************************/

@media (min-width: 1024px) {
  .timeline-box p {
    min-height: 100px;
  }
}
@media (max-width: 1024px) {
  .timeline-row:last-child .timeline-box {
    width: auto;
    z-index: 1;
    margin-top: 0% !important;
    margin-left: 0% !important;
  }
}
@media screen and (max-width: 1800px) {
  .timeline-box p {
    width: 75%;
  }
  .timeline-row:nth-child(2n + 2) .timeline-box p {
    width: 83%;
  }
}

@media screen and (max-width: 1600px) {
  h1 {
    font-size: 64px;
  }
  h2 {
    font-size: 50px;
  }
  h3 {
    font-size: 40px;
  }
  h4 {
    font-size: 34px;
  }
  h5 {
    font-size: 30px;
  }
  h6 {
    font-size: 24px;
  }
  p,
  li {
    font-size: 20px;
  }
  .timeline-box p {
    width: 80%;
    padding: 30px;
  }
  .timeline-box h6 {
    width: 100px;
    height: 100px;
    margin-top: -50px;
  }
  .timeline-row:nth-child(2n + 2) .timeline-box p {
    width: 86%;
  }
  .timeline-row:nth-child(2n + 2) {
    padding-left: 4%;
  }
}

@media screen and (max-width: 1400px) {
  h1 {
    font-size: 56px;
  }
  h2 {
    font-size: 46px;
  }
  h3 {
    font-size: 36px;
  }
  h4 {
    font-size: 30px;
  }
  h5 {
    font-size: 26px;
  }
  h6 {
    font-size: 21px;
  }
  p,
  li {
    font-size: 18px;
  }
  .timeline-box h6 {
    width: 90px;
    height: 90px;
    margin-top: -46px;
  }
  .timeline-box p {
    width: 80%;
    padding: 25px;
    margin: 20px 0 0 40px;
    font-size: 15px;
  }
  .timeline-row {
    padding-bottom: 110px;
  }
  .timeline-row:last-child {
    padding-bottom: 60px;
  }
  .timeline-sec {
    padding: 20px 0 90px 0;
  }
  .timeline-box::after,
  .timeline-row:nth-child(2n + 2)::after,
  .timeline-row::after {
    width: 34px;
    height: 34px;
    background-size: 100%;
  }
  .timeline-row:last-child::after {
    left: 4%;
    width: 46%;
  }
  .timeline-row:nth-last-child(1):nth-child(even):after {
    right: 4%;
    left: initial;
  }
  .timeline-row:last-child .timeline-box h6 {
    margin-top: -41px;
  }
}

@media screen and (max-width: 1199px) {
  h1 {
    font-size: 50px;
  }
  h2 {
    font-size: 40px;
  }
  h3 {
    font-size: 31px;
  }
  h4 {
    font-size: 28px;
  }
  h5 {
    font-size: 24px;
  }
  h6 {
    font-size: 20px;
  }
  .timeline-sec {
    padding: 10px 0 90px 0;
  }
  .timeline-box p {
    padding: 20px;
    font-size: 14px;
  }
  .timeline-box h6 {
    width: 84px;
    height: 84px;
    margin-top: -42px;
  }
  .timeline-row {
    padding-bottom: 100px;
  }
  .timeline-row:nth-child(2n + 2) {
    padding-left: 2%;
  }
  .timeline-row:last-child {
    padding-bottom: 50px;
  }
  .timeline-box::after,
  .timeline-row:nth-child(2n + 2)::after,
  .timeline-row::after {
    width: 30px;
    height: 30px;
  }
  .timeline-row:last-child .timeline-box h6 {
    margin-top: -35px;
    font-size: 14px;
    width: 70px;
    height: 70px;
  }
}

@media screen and (max-width: 1024px) {
  h1 {
    font-size: 44px;
  }
  h2 {
    font-size: 36px;
  }
  h3 {
    font-size: 28px;
  }
  h4 {
    font-size: 26px;
  }
  h5 {
    font-size: 22px;
  }
  h6 {
    font-size: 18px;
  }
  p,
  li {
    font-size: 16px;
  }
  .timeline-sec {
    padding: 0px 0 80px 0;
  }
  .timeline-row .horizontal-line,
  .timeline-row .verticle-line,
  .corner {
    display: none;
  }
  .timeline-row::after,
  .timeline-row:nth-child(2n + 2)::after {
    display: none;
  }
  .timeline-box::after,
  .timeline-row:nth-child(2n + 2) .timeline-box::after {
    -webkit-transform: translate(-50%, 100%) rotate(90deg);
    transform: translate(-50%, 100%) rotate(90deg);
    top: 50%;
    left: 50%;
  }
  .timeline-box::after,
  .timeline-row:nth-child(2n + 2)::after,
  .timeline-row::after {
    width: 26px;
    height: 26px;
  }
  .timeline-row {
    padding-bottom: 0;
  }
  .timeline-box {
    width: 100%;
    padding-bottom: 30px;
  }
  .timeline-row:last-child {
    padding-bottom: 20px;
  }
  .timeline-row:nth-child(2n + 2) .timeline-box {
    width: 100%;
  }
  .timeline-box h6 {
    width: 80px;
    height: 80px;
    margin-top: 0;
    margin: 0 auto;
  }
  .timeline-box p,
  .timeline-row:nth-child(2n + 2) .timeline-box p {
    width: 41%;
    margin: -40px 0 0 0;
  }
  .timeline-row:last-child .timeline-box h6 {
    margin-top: 0;
    font-size: 13px;
    width: 66px;
    height: 66px;
  }
  .timeline-row:nth-child(2n + 2) {
    padding-left: 0;
  }
  .timeline-box p::before {
    left: auto;
    right: -16px;
    border-bottom: 0px solid #f7f7f7;
    border-top: 15px solid #f7f7f7;
    top: 0;
  }
  .timeline-box:nth-child(2n + 2) {
    text-align: right;
  }
  .timeline-box:nth-child(2n + 2) p {
    display: inline-block;
    text-align: left;
  }
  .timeline-box:nth-child(2n + 2) p::before {
    left: -16px;
    right: auto;
    border-bottom: 0px solid #f7f7f7;
    border-top: 15px solid #f7f7f7;
    top: 0;
    border-left: 15px solid transparent;
  }
  .timeline-row:nth-child(2n + 2) .timeline-box:nth-child(2n + 1) {
    text-align: right;
  }
  .timeline-row:nth-child(2n + 2) .timeline-box:nth-child(2n + 1) p {
    display: inline-block;
    text-align: left;
  }
  .timeline-row:nth-child(2n + 2) .timeline-box:nth-child(2n + 1) p::before {
    left: -16px;
    right: auto;
    border-bottom: 0px solid #f7f7f7;
    border-top: 15px solid #f7f7f7;
    top: 0;
    border-left: 15px solid transparent;
  }
  .timeline-row:nth-child(2n + 2) .timeline-box:nth-child(2n + 2) {
    text-align: left;
  }
  .timeline-row:nth-child(2n + 2) .timeline-box:nth-child(2n + 2) p::before {
    left: auto;
    right: -16px;
    border-bottom: 0px solid #f7f7f7;
    border-top: 15px solid #f7f7f7;
    top: 0;
  }
  .verticle-line {
    display: block !important;
    left: 50%;
    z-index: -1;
    height: calc(100% - 0px) !important;
    transform: translate(-50%, 0%);
    -webkit-transform: translate(-50%, 0%);
  }
  .timeline-row:nth-child(2n + 2) .verticle-line {
    left: 50%;
  }
  .timeline-row:nth-child(2n + 2) {
    flex-direction: unset;
  }
  .timeline-row:nth-child(2n + 2) .timeline-box:nth-child(3)::after {
    display: block;
  }
}

@media screen and (max-width: 767px) {
  h1 {
    font-size: 40px;
  }
  h2 {
    font-size: 31px;
  }
  h3 {
    font-size: 26px;
  }
  h4 {
    font-size: 24px;
  }
  h5 {
    font-size: 20px;
  }
  h6 {
    font-size: 16px;
  }
  p,
  li {
    font-size: 15px;
  }
  .timeline-sec {
    padding: 0px 0 70px 0;
  }
  .timeline-box h6 {
    width: 70px;
    height: 70px;
  }
  .timeline-row:last-child .timeline-box h6 {
    font-size: 12px;
    width: 60px;
    height: 60px;
  }
  .font-weight-normal p br {
    display: none;
  }
  .timeline-row:last-child {
    padding-bottom: 0;
  }
  .timeline-box p,
  .timeline-row:nth-child(2n + 2) .timeline-box p {
    width: 40%;
    margin: -38px 0 0 0;
  }
}

@media screen and (max-width: 640px) {
  h1 {
    font-size: 36px;
  }
  h2 {
    font-size: 28px;
  }
  h3 {
    font-size: 24px;
  }
  h4 {
    font-size: 22px;
  }
  h5 {
    font-size: 18px;
  }
  h6 {
    font-size: 16px;
  }
  p,
  li {
    font-size: 14px;
  }
  .timeline-sec {
    padding: 0px 0 60px 0;
  }
  .timeline-box h6 {
    margin: 0;
  }
  .verticle-line,
  .timeline-row:nth-child(2n + 2) .verticle-line {
    left: 35px;
  }
  .timeline-row:last-child {
    justify-content: flex-start;
  }
  .timeline-row:last-child .timeline-box {
    margin: 0 0 0 6px;
  }
  .timeline-box {
    text-align: right;
    padding-bottom: 20px;
  }
  .timeline-box p,
  .timeline-row:nth-child(2n + 2) .timeline-box p {
    width: 78%;
    margin: -38px 0 0 0;
    display: inline-block;
    text-align: left;
    font-size: 13px;
  }
  .timeline-box p::before,
  .timeline-row:nth-child(2n + 2) .timeline-box:nth-child(2n + 2) p::before {
    left: -14px;
    right: 0;
    border-bottom: 0px solid #f7f7f7;
    border-top: 15px solid #f7f7f7;
    top: 0;
    border-top: 15px solid #f7f7f7;
    border-left: 15px solid transparent;
    border-right: 0px solid transparent;
  }
  .timeline-box:nth-child(2n + 2) p::before,
  .timeline-row:nth-child(2n + 2) .timeline-box:nth-child(2n + 1) p::before {
    left: -14px;
  }
  .timeline-row:nth-child(2n + 2) .timeline-box:nth-child(2n + 2) {
    text-align: right;
  }
  .timeline-box::after,
  .timeline-row:nth-child(2n + 2)::after,
  .timeline-row::after {
    width: 24px;
    height: 24px;
    left: 35px;
  }
  .timeline-box::after,
  .timeline-row:nth-child(2n + 2) .timeline-box::after {
    left: 35px;
  }
}

@media screen and (max-width: 480px) {
  h1 {
    font-size: 33px;
  }
  h2 {
    font-size: 26px;
  }
  h3 {
    font-size: 22px;
  }
  h4 {
    font-size: 20px;
  }
  h5 {
    font-size: 16px;
  }
  h6 {
    font-size: 15px;
  }
  .timeline-box p,
  .timeline-row:nth-child(2n + 2) .timeline-box p {
    width: 70%;
    padding: 15px;
  }
  .timeline-sec {
    padding: 0px 0 50px 0;
  }
  .heading3 h3 {
  font-size: 15px;
  padding-top: 15px;
}
}

.timelinelast {
  height: auto;
  width: auto;
  max-height: 70px;
  max-width: 100px;
  float: right;
}

.iframe-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  height: 0;
}

.iframe-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
